import React from 'react'
import { Col, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Item = ({ name, image }) => {
  return (
    <Col className='gy-2 gy-md-4 gx-3 d-flex flex-column position-relative'lg={4} md={6} sm={12} >
      <Link to={`/${name}`}>
        <Image src={image} fluid style={{maxHeight:"240px", objectFit: "cover"}} />
      </Link>
      <Link className='text-decoration-none' to={`/${name}`}><h4 className='display-6 text-capitalize text- h-t-black'>{name.split(" ")[0]}</h4></Link>
      {/* {tag && <p style={{transform:"rotate(90deg)"}} className={`position-absolute px-2 py-1 ${tag === "New" ? "bg-info": "bg-danger text-light"} my-3 mx-2 fs-4`}>{tag}</p>} */}
    </Col>
  )
}

export default Item